module.exports = __webpack_public_path__ + "static/media/cases_3d_02d.8f627604.jpg";